import { getQaSelector } from '../../../../utils/common'
import { useApplicantProfileContext } from '../RentalPortalApplicantProfile.hooks'

import { ApplicantCreditCheckBlock } from './ApplicantCreditCheckBlock'
import { ApplicantDecisionPanel } from './ApplicantDecisionPanel'
import { ApplicantDocumentChecklist } from './ApplicantDocumentChecklist'
import { ApplicantFitCheckBlock } from './ApplicantFitCheckBlock'
import { ApplicantIdentityWidget } from './ApplicantIdentityWidget'
import { ApplicantMatchingWidget } from './ApplicantMatchingWidget'
import { ApplicantNotesBlock } from './ApplicantNotesBlock'
import { ApplicantViewingCard } from './ApplicantViewingCard'
import { QA_NAME_APPLICANT_PROFILE_OVERVIEW } from './RentalPortalApplicantProfileTabOverview.constants'
import {
  getHasApplicantCreditCheckBlock,
  getHasApplicantScreeningBlocks,
} from './RentalPortalApplicantProfileTabOverview.utils'

import * as styles from './RentalPortalApplicantProfileTabOverview.module.css'

function RentalPortalApplicantProfileTabOverview() {
  const { applicantData, isInitiated } = useApplicantProfileContext()

  return (
    <div
      {...getQaSelector({ value: QA_NAME_APPLICANT_PROFILE_OVERVIEW })}
      className={styles.RentalPortalApplicantProfileTabOverview}
    >
      <ApplicantIdentityWidget />
      <ApplicantFitCheckBlock />
      <ApplicantMatchingWidget />
      {getHasApplicantScreeningBlocks(applicantData) ? (
        <ApplicantDocumentChecklist />
      ) : null}
      {getHasApplicantCreditCheckBlock(applicantData) ? (
        <ApplicantCreditCheckBlock />
      ) : null}
      {!isInitiated || getHasApplicantScreeningBlocks(applicantData) ? (
        <ApplicantDecisionPanel />
      ) : null}
      <ApplicantViewingCard />
      <ApplicantNotesBlock />
    </div>
  )
}

export default RentalPortalApplicantProfileTabOverview
